import React from "react";
import "react-loading-skeleton/dist/skeleton.css";

const Loading = ({
  count = 5,
  size = "4xl",
  type = "default",
  header = "Loading...",
}) => {
  return (
    <>
      {type === "round" ? (
        <i className="block text-center py-48 text-5xl text-violet-600 fad fa-circle-notch fa-spin" />
      ) : (
        <div className={`text-${size}`}>
          <p className="text-sm text-center text-gray-900">
            {" "}
            {header}
          </p>
          <div className="animate-pulse">
            {Array.from({ length: count }).map((_, index) => (
              <div
                key={index}
                className="h-4 my-2 bg-gray-200 rounded animate-pulse"
              ></div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
